import { z } from 'zod'

export const PAYMENT_METHOD_BRANDS = ['VISA', 'MasterCard', 'JCB'] as const
export type PaymentMethodBrand = (typeof PAYMENT_METHOD_BRANDS)[number]

export const PAYMENT_METHOD_TYPES = ['credit_card', 'bank_account'] as const
export type PaymentMethodType = (typeof PAYMENT_METHOD_TYPES)[number]

const dayOrEndOfMonth = z.union([
  z.object({ day: z.number().int().min(1).max(31), endOfMonth: z.literal(false).optional() }),
  z.object({ endOfMonth: z.literal(true), day: z.undefined().optional() }),
])

const baseShape = {
  name: z.string().trim().min(1, { message: '名前を入力してください' }),
  scope: z.enum(['household', 'personal']),
  color: z.string().optional().nullable(),
  is_active: z.boolean().optional(),
}

export const creditCardSchema = z.object({
  ...baseShape,
  type: z.literal('credit_card'),
  brand: z.enum(PAYMENT_METHOD_BRANDS),
  last4: z.string().regex(/^\d{4}$/, { message: '下4桁を数字4桁で入力してください' }),
  closing: dayOrEndOfMonth,
  payment: dayOrEndOfMonth,
  paymentMonthOffset: z.union([z.literal(1), z.literal(2)]),
})

export const bankAccountSchema = z.object({
  ...baseShape,
  type: z.literal('bank_account'),
  bankName: z.string().trim().optional().nullable(),
  branchName: z.string().trim().optional().nullable(),
})

export const paymentMethodSchema = z.discriminatedUnion('type', [creditCardSchema, bankAccountSchema])

export type CreditCardInput = z.infer<typeof creditCardSchema>
export type BankAccountInput = z.infer<typeof bankAccountSchema>
export type PaymentMethodInput = z.infer<typeof paymentMethodSchema>
